const MENU = {
  dashboard: 'Dashboard',
  product_catalog: 'Produkte und Systeme',
  system_applications: 'Anwendungsbereiche',
  cart: 'Warenkorb',
  scanner: 'QR Scanner',
  mixer: 'Mischer',
  qcvmixer: 'QCV Mixer',
  elasticmixer: 'Flakes Mixer',
};

export default MENU;
